import { Spine } from '@esotericsoftware/spine-pixi-v8';
import {
    Container, /*Sprite,*/ Graphics,
    Sprite
} from 'pixi.js';
// import { /*spinResponse,*/ initData/*, SpinDataObject/*, spinData /*, WinObject*/ } from '../server/getServerResposesFun'
import { EventEmitter } from "pixi.js";

export const reelSpinEmitter = new EventEmitter();

// import { sound } from '@pixi/sound';
import { sound } from '@pixi/sound';
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";
import * as PIXI from "pixi.js";
import { Logo } from '../components/Logo';
import { LogoComponent } from '../components/LogoComponent';
import { getSpineSymbol, getSymbol } from '../config/getSymbol';
import { isSuperQuickBtnOnGlobal, RespinIndex } from '../config/GlobalVariableConfig';
import {
    ANTICIPATION_CONFIG,
    LOGO_Y,
    REEL_BG_POS_ALL,
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_SCALE,
    REEL_WIDTH,
    REEL_x_POS,
    REEL_y_POS,
    setVisibleSymbols,
    SYMBOL_HEIGHT,
    SYMBOL_WIDTH,
    SYMBOLS_PER_REEL,
    VISIBLE_SYMBOLS_PER_REEL,
    WILD_ANTICIPATION_POS
} from "../config/reelConfig";
import { DisplayComponent } from '../core/displays/DisplayComponent';
// import { GSAPScreenShake } from '../core/GSAPScreenShake';
import { Manager } from '../core/Manager';
import { GameConstants } from '../gameClientEvents/GameConstants';
import { spinData } from '../server/getServerResposesFun';

gsap.registerPlugin(PixiPlugin);
PixiPlugin.registerPIXI(PIXI);

export const DummyReelSymbol = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3, 6, 8, 1, 6, 3, 8, 6, 1, 6, 8, 3, 6, 1, 3, 8, 6, 1, 3, 8, 6, 3, 1, 6, 8, 3, 6, 1, 3, 8, 1, 3, 8, 6, 1, 3, 8, 3, 6, 3, 1, 8, 3, 6, 8, 1, 3, 8, 3, 6, 8, 1, 3, 6, 8, 1, 3, 6, 8, 3, 6, 8, 3, 3, 6, 8, 1, 3, 6, 8, 3, 1, 8, 3]
    , [2, 7, 4, 2, 7, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 2, 2, 7, 4, 2, 7, 2, 4, 7, 2, 4, 7, 2, 2, 7, 2, 4, 2, 7, 4, 2, 2, 7, 2, 7, 4, 2, 7, 2, 4, 2]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
]

export const DummyReelSymbol1 = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
]

export interface SymbolObject {
    symbolIndex: number
    id: number;
    y: number
    view: Container;
    symbol: Sprite;
}

export interface ReelObject {
    reelIndex: number
    container: Container;
    symbols: SymbolObject[];
}




export class ReelInit extends Container {

    public allReelArray: ReelObject[];
    public anticipation: Spine[];
    public wildAnticipation: Spine;

    private allReelContainer: Container;

    public reelOverlayContainer: Container;
    public toggleOverlayContainer: Container;
    public topOverlayContainer: Container;
    public reelSymbolContainers: Container[][] = [];
    public reelSymbols: Spine[][] = [];


    // private mouseMeterContainer = new Container();
    // private mouseMeter: Spine[] = [];
    // private isMouseDown: boolean[] = [];

    // public mouseMultVal: number[] = [];
    // public mouseMultText: BitmapText[] = [];
    // public multiplierValTotal: number = 0;

    public reelSymbolsBeforeSpin: number[][] = [];
    private maskTimeline: gsap.core.Timeline | null = null;
    private isAfterFreeSpin: boolean = false;

    private holdAndWinTrigger: Spine | null = null;

    constructor() {
        super();

        this.allReelContainer = new Container();
        this.allReelArray = [];
        this.reelOverlayContainer = new Container();
        this.toggleOverlayContainer = new Container();
        this.topOverlayContainer = new Container();
        this.toggleOverlayContainer.label = "toggleOverlay";
        this.anticipation = [];

        // this.reelOverlayContainer.visible=false;

        this.initReels();

    }

    private initReels() {

        // this.setupmouseMeter();
        let prevXPos = 0;
        const reelBackLeft = Sprite.from('reelBackleft');
        const reelBackMid = Sprite.from('reelBackMid');
        const reelBackRight = Sprite.from('reelBackRight');
        //const midReelsContainer = new Container();
        const middleReelVisibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const config = configObj ? configObj[middleReelVisibleCount as keyof typeof configObj] : null;

        for (let i = 0; i < REEL_NUMBERS; i++) {
            let lastY = 0;
            const reelContainer = new Container();
            const reelBgContainer = new Container();
            let rn = (i > 0 && i < 4) ? 1 : (i === 4 ? 2 : i);
            const reelObj: ReelObject = {
                reelIndex: i,
                container: reelContainer,
                symbols: [],
                // symbolIds: [],
                // symbols: [],
                // indexOfContInView: 0
            };


            let currentXPos = (i === 0) ? REEL_x_POS : prevXPos + REEL_WIDTH + REEL_DIVIDER[i];
            reelContainer.x = currentXPos;
            prevXPos = reelContainer.x;
            reelContainer.y = reelBgContainer.y = REEL_y_POS[i];
            reelContainer.label = `Reel_${i}`;

            const reelGrid = Sprite.from('baseGameGrid');
            reelGrid.label = `baseReelGrid_${i}`;
            reelGrid.x = REEL_FRAME;
            reelGrid.y = REEL_FRAME;
            reelContainer.addChildAt(reelGrid, 0);

            if (i == 0) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.addChild(reelBackRight);
            }
            if (i == 1) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.label = "reelBackMid";
                reelBgContainer.addChild(reelBackMid);
            }
            if (i == 4) {
                reelBgContainer.position.set(config[rn].bgX, config[rn].bgY);
                reelBgContainer.addChild(reelBackLeft);
            }
            const resumeSymbolIndex = this.getSymbolDataAfterFG();
            this.isAfterFreeSpin = resumeSymbolIndex !== null;

            const reelRand = Math.floor(Math.random() * (DummyReelSymbol[i].length - SYMBOLS_PER_REEL[i]));
            const reelSymbolIds = resumeSymbolIndex === null
                ?
                DummyReelSymbol[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL[i] + 1)
                :
                [...spinData.respins[resumeSymbolIndex].reelSymbols[i]];

            this.reelSymbolsBeforeSpin.push([...reelSymbolIds]);

            for (let j = 0; j < SYMBOLS_PER_REEL[i] + 1; j++) {
                const symbolContainer = new Container();

                let index = (j == SYMBOLS_PER_REEL[i]) ? j - 1 : j;
                const symbolId = reelSymbolIds[index];

                let symbol = new Sprite(getSymbol(symbolId, true));

                symbolContainer.addChild(symbol);
                symbol.anchor = 0.5;
                symbolContainer.y = (SYMBOL_HEIGHT / 2) + j * SYMBOL_HEIGHT;
                symbolContainer.x = Math.round(SYMBOL_WIDTH / 2);

                if (j == SYMBOLS_PER_REEL[i]) { // the extra symbol - which will appear on top of mark - having (symbolIndex = SYMBOLS_PER_REEL)
                    symbolContainer.y = - (SYMBOL_HEIGHT / 2);
                }
                const symbolObj: SymbolObject = {
                    symbolIndex: j,
                    id: symbolId,
                    y: symbolContainer.y,
                    view: symbolContainer,
                    symbol: symbol,
                }

                reelObj.symbols.push(symbolObj);
                reelContainer.addChild(symbolContainer);
                if (symbolContainer.y > lastY) {
                    lastY = symbolContainer.y;
                }
            }



            if (i === 0 || i === 1 || i === 4) {
                this.allReelContainer.addChild(reelBgContainer);
            }
            this.allReelContainer.addChild(reelContainer);
            this.allReelArray.push(reelObj);

            this.anticipation[i] = Spine.from({
                skeleton: "anticipationSkel",
                atlas: "anticipationAtlas",
            });

            const anticipationConfigObj = ANTICIPATION_CONFIG.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
            const aConfig = configObj ? anticipationConfigObj[middleReelVisibleCount as keyof typeof configObj] : null;
            this.anticipation[i].x = aConfig.x
            this.anticipation[i].y = aConfig.y;
            this.anticipation[i].scale.y = aConfig.scaleY;

            if (i === 4) {
                this.wildAnticipation = Spine.from({
                    skeleton: "wildAnticipationSkel",
                    atlas: "wildAnticipationAtlas",
                })
                this.wildAnticipation.label = "wild Anticipation";
                this.wildAnticipation.position.set(WILD_ANTICIPATION_POS.x, WILD_ANTICIPATION_POS.y);
            }

            if (Array.isArray(SYMBOLS_PER_REEL)) {
                const visibleCount = VISIBLE_SYMBOLS_PER_REEL[i];
                const totalHeight = SYMBOL_HEIGHT * visibleCount;
                const bottomY = lastY + (SYMBOL_HEIGHT / 2);

                const topY = bottomY - totalHeight;

                const reelMask = new Graphics()
                    .rect(0, 0, REEL_WIDTH, totalHeight)
                    .fill(0x950a5a);

                reelMask.x = REEL_FRAME;
                reelMask.y = topY;
                reelMask.y = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[i]) - totalHeight;
                reelMask.label = `reelMask_${i}`;
                reelContainer.addChild(reelMask);
                reelMask.alpha = .5;
                reelContainer.mask = reelMask;
            }

        }

        if (!Array.isArray(SYMBOLS_PER_REEL)) {
            const reactMark = new Graphics().rect(REEL_FRAME, REEL_FRAME, REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER[0], SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
            this.allReelContainer.addChild(reactMark);
            reactMark.alpha = .5;
            this.allReelContainer.mask = reactMark;
        }

        this.addChild(this.allReelContainer);

        this.reelOverlayContainer.destroy(true);
        this.toggleOverlayContainer.destroy(true);
        this.topOverlayContainer.destroy(true);
        this.position.set(1500, 1500);
        this.animateMask(null, true);
        this.initReelOverlayContainer();
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.addReelSymbolsToContainer(i);
        }
        this.isAfterFreeSpin = false;

        this.setupTriggerText();
    }

    private getSymbolDataAfterFG(): number | null {
        if (RespinIndex.value === 0 || !spinData.respins?.length) return null;

        const respins = spinData.respins;
        const maxStartIndex = Math.min(RespinIndex.value - 1, respins.length - 1);

        const isDisplayable = (i: number) => {
            const r = respins[i];
            return !!(r?.reelSymbols?.length &&
                r.type !== "feature_enter" &&
                r.type !== "feature_exit" &&
                r.type !== "max_win_reached"
            );
        };

        // Walk back to find last displayable respin
        let lastDisplayableIndex = -1;
        for (let i = maxStartIndex; i >= 0; i--) {
            if (isDisplayable(i)) { lastDisplayableIndex = i; break; }
        }

        if (lastDisplayableIndex === -1) return null;

        // If it's a H&S result, walk back further to find its trigger
        const isHoldAndSpinResult = !!respins[lastDisplayableIndex]?.featureData?.coinInfo;
        if (!isHoldAndSpinResult) return lastDisplayableIndex;

        for (let i = lastDisplayableIndex; i >= 0; i--) {
            if (isDisplayable(i) && respins[i]?.featureData?.isHoldAndSpin) return i;
        }

        return lastDisplayableIndex;
    }

    private setupTriggerText() {
        this.holdAndWinTrigger = Spine.from({
            skeleton: "holdWinTextSkel",
            atlas: "holdWinTextAtlas"
        });
        this.holdAndWinTrigger.label = "holdAndWinTrigger text";
        this.holdAndWinTrigger.visible = false;
        this.topOverlayContainer.addChild(this.holdAndWinTrigger);

        // Positioning according to reel Frame and visible symbols
        // const visibleRows = VISIBLE_SYMBOLS_PER_REEL[2]; // middle reel
        // const totalHeight = visibleRows * SYMBOL_HEIGHT;

        // const centerX = (REEL_WIDTH * REEL_NUMBERS) / 2;
        // const centerY = totalHeight / 2;

        this.holdAndWinTrigger.position.set(610, 535);
        this.holdAndWinTrigger.scale = 1;
    }

    public appearHoldAndWinText(): Promise<void> {
        return new Promise<void>((resolve) => {
            if (!this.holdAndWinTrigger) {
                resolve();
                return;
            }
            const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            this.holdAndWinTrigger.visible = true;
            sound.play("hold_and_win", { volume: 1, speed: timeScale })
            this.holdAndWinTrigger.state.setAnimation(0, "animation", false).listener = {
                complete: () => {
                    this.holdAndWinTrigger.state.clearListeners();
                    this.holdAndWinTrigger.visible = false;
                    resolve();
                }
            };
        });
    }

    // private setupmouseMeter() {

    //     this.mouseMeterContainer.label = "mouseMeterContainer";
    //     // this.addChild(this.mouseMeterContainer);
    //     this.mouseMeterContainer.position.set(76, -76);
    //     const meterSpacing = 190;
    //     const meterStartX = 0;

    //     //         public mouseMultVal: number[] = [];
    //     // public mouseMultText: BitmapText[] = [];
    //     //     this.multiplierText.anchor = 0.5;

    //     for (let i = 0; i < REEL_NUMBERS; i++) {

    //         // const mouse = Spine.from({
    //         //     skeleton: "reelMouseSkel",
    //         //     atlas: "reelMouseAtlas"
    //         // });

    //         // mouse.state.setAnimation(0, "end", false);
    //         // this.mouseMeter.push(mouse);
    //         // mouse.position.set(meterStartX + i * meterSpacing, 0); // Adjust Y position as needed
    //         // this.mouseMeterContainer.addChild(mouse);

    //         // this.isMouseDown.push(true);


    //         // const mouseMultVal = 1;
    //         // const mouseMultText = new BitmapText({
    //         //     text: `${mouseMultVal}x`,
    //         //     style: {
    //         //         fontFamily: 'dtt_coin_font',
    //         //         fontSize: 70
    //         //     }
    //         // });
    //         // mouseMultText.anchor = 0.5;
    //         // this.mouseMultVal.push(mouseMultVal);
    //         // this.mouseMultText.push(mouseMultText);
    //         // mouseMultText.position.set(10 + mouse.x, -45);
    //         // mouseMultText.scale = 0;
    //         // this.mouseMeterContainer.addChild(mouseMultText);

    //     }
    // }

    public resetMask() {
        this.wildAnticipation.visible = false;
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            this.allReelArray[reelNum].container.mask = null;
            const maskToRemove = this.allReelArray[reelNum].container.getChildByName(`reelMask_${reelNum}`);
            if (maskToRemove) {
                this.allReelArray[reelNum].container.removeChild(maskToRemove);
            }

            if (Array.isArray(SYMBOLS_PER_REEL)) {
                const visibleCount = VISIBLE_SYMBOLS_PER_REEL[reelNum];
                const totalHeight = SYMBOL_HEIGHT * visibleCount;

                const reelMask = new Graphics()
                    .rect(0, 0, REEL_WIDTH, totalHeight)
                    .fill(0x950a5a);

                reelMask.x = REEL_FRAME;
                reelMask.y = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[reelNum]) - totalHeight;
                reelMask.label = `reelMask_${reelNum}`;
                this.allReelArray[reelNum].container.addChild(reelMask);
                reelMask.alpha = .5;
                this.allReelArray[reelNum].container.mask = reelMask;
            }
        }
    }

    public animateMask2(heights?: number[]) {
        if (heights) {
            setVisibleSymbols(heights);
        }

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            const container = this.allReelArray[reelNum].container;

            let reelMask = container.getChildByName(`reelMask_${reelNum}`) as Graphics;

            if (!reelMask) {
                reelMask = new Graphics()
                    .rect(0, 0, REEL_WIDTH, 1)
                    .fill(0x950a5a);

                reelMask.label = `reelMask_${reelNum}`;
                reelMask.x = REEL_FRAME;
                container.addChild(reelMask);
                container.mask = reelMask;
            }

            const visibleCount = VISIBLE_SYMBOLS_PER_REEL[reelNum];
            const targetHeight = SYMBOL_HEIGHT * visibleCount;
            const targetY = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[reelNum]) - targetHeight;

            gsap.to(reelMask, {
                height: targetHeight,
                y: targetY,
                duration: 0.5,
                ease: "power2.out"
            });
        }
    }

    public animateMask1(heights?: number[]) {

        if (this.maskTimeline) {
            this.maskTimeline.pause();
            this.maskTimeline.kill();
            this.maskTimeline = null;
        }

        if (heights) {
            setVisibleSymbols(heights);
        }

        const speedMultiplier = isSuperQuickBtnOnGlobal ? 5.5 : 1;

        this.maskTimeline = gsap.timeline({
            defaults: {
                duration: 0.5,
                ease: "power2.out",
                overwrite: true,
                immediateRender: false
            }
        });

        this.maskTimeline.timeScale(speedMultiplier);

        const middleReelVisibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const config = configObj ? configObj[middleReelVisibleCount as keyof typeof configObj] : null;

        if (config) {
            const midBgData = config[1];
            let middleBgContainer = this.allReelContainer.getChildByName("reelBackMid", true) as Container;

            if (middleBgContainer) {

                gsap.killTweensOf(middleBgContainer);
                this.maskTimeline.to(middleBgContainer, {
                    pixi: {
                        x: midBgData.bgX, y: midBgData.bgY,
                        scaleX: midBgData.bgScaleX, scaleY: midBgData.bgScaleY
                    }
                }, 0);
            }

            let parentCont = this.allReelContainer.parent as Container;
            if (parentCont) {
                let orientationScale = (Manager.Orientation === "LANDSCAPE") ? REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)] : 1;
                gsap.killTweensOf(parentCont);
                this.maskTimeline.to(parentCont, {
                    pixi: { scale: orientationScale }
                }, 0);

                // GSAPScreenShake.stop();
                // GSAPScreenShake.shake([this], 1500 / speedMultiplier);
                this.triggerLogoShake();
            }
        }

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            const container = this.allReelArray[reelNum].container;
            let reelMask = container.getChildByName(`reelMask_${reelNum}`) as Graphics;

            gsap.killTweensOf(container);
            if (reelMask) {
                gsap.killTweensOf(reelMask);
            } else {
                reelMask = new Graphics().rect(0, 0, REEL_WIDTH, 1).fill(0x950a5a);
                reelMask.label = `reelMask_${reelNum}`;
                reelMask.x = REEL_FRAME;
                container.addChild(reelMask);
                container.mask = reelMask;
            }

            const visibleCount = VISIBLE_SYMBOLS_PER_REEL[reelNum];
            const targetHeight = SYMBOL_HEIGHT * visibleCount;
            const targetY = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[reelNum]) - targetHeight;

            this.maskTimeline.to(reelMask, {
                pixi: { height: targetHeight, y: targetY }
            }, 0);

            if (config) {
                let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : reelNum);
                this.maskTimeline.to(container, {
                    pixi: { y: config[rn].reelY }
                }, 0);
            }
        }
    }

    public animateMask(heights?: number[], skipAnimation: boolean = false, isReset: boolean = false) {
        if (this.maskTimeline) {
            this.maskTimeline.kill();
            this.maskTimeline = null;
        }

        if (heights) {
            setVisibleSymbols(heights);
        }

        const speedMultiplier = isSuperQuickBtnOnGlobal ? 5.5 : 1;
        const middleReelVisibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const config = configObj ? configObj[middleReelVisibleCount as keyof typeof configObj] : null;

        const anticipationConfigObj = ANTICIPATION_CONFIG.find(obj => obj.hasOwnProperty(middleReelVisibleCount));
        const aConfig = configObj ? anticipationConfigObj[middleReelVisibleCount as keyof typeof configObj] : null;

        if (!skipAnimation) {
            this.maskTimeline = gsap.timeline({
                defaults: { duration: 0.6, ease: "expo.out", overwrite: true }
            });
            this.maskTimeline.timeScale(speedMultiplier);
        }

        const anticipationProps = {
            pixi: {
                x: aConfig.x,
                y: aConfig.y,
                scaleY: aConfig.scaleY
            }
        }

        if (config) {
            const midBgData = config[1];
            let middleBgContainer = this.allReelContainer.getChildByName("reelBackMid", true) as Container;
            const parentCont = this.allReelContainer.parent as Container;

            const bgProps = {
                pixi: {
                    x: midBgData.bgX, y: midBgData.bgY,
                    scaleX: midBgData.bgScaleX, scaleY: midBgData.bgScaleY
                }
            };

            const logoProps = {
                pixi: {
                    y: LOGO_Y[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)]
                }
            };

            let orientationScale = (Manager.Orientation === "LANDSCAPE") ? REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)] : 1;

            const parentProps = {
                pixi: { scale: orientationScale },
                duration: 0.6,
                ease: "expo.inOut"
            };

            if (skipAnimation) {
                if (middleBgContainer) gsap.set(middleBgContainer, bgProps);
                if (Manager.Orientation === "PORTRAIT") gsap.set((DisplayComponent.get(LogoComponent).getInstance()), logoProps);
                if (parentCont) gsap.set(parentCont, parentProps);
            } else {
                if (middleBgContainer) this.maskTimeline!.to(middleBgContainer, bgProps, 0);
                if (Manager.Orientation === "PORTRAIT") this.maskTimeline!.to((DisplayComponent.get(LogoComponent).getInstance()), logoProps, 0);
                if (parentCont) {
                    this.maskTimeline!.to(parentCont, parentProps, 0.1);
                    // GSAPScreenShake.stop();
                    // GSAPScreenShake.shake([this], 1500 / speedMultiplier);
                    this.triggerLogoShake();
                }
            }
        }

        if (isReset) {
            this.playReelResetShake();
        }

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            const container = this.allReelArray[reelNum].container;
            let reelMask = container.getChildByName(`reelMask_${reelNum}`) as Graphics;

            if (!reelMask) {
                reelMask = new Graphics().rect(0, 0, REEL_WIDTH, 1).fill(0x950a5a);
                reelMask.label = `reelMask_${reelNum}`;
                reelMask.x = REEL_FRAME;
                container.addChild(reelMask);
                container.mask = reelMask;
            }

            const visibleCount = VISIBLE_SYMBOLS_PER_REEL[reelNum];
            const targetHeight = SYMBOL_HEIGHT * visibleCount;
            const targetY = (SYMBOL_HEIGHT * SYMBOLS_PER_REEL[reelNum]) - targetHeight;

            const maskProps = { pixi: { height: targetHeight, y: targetY } };

            let anticipationAnim = this.anticipation[reelNum];


            if (skipAnimation) {
                gsap.set(reelMask, maskProps);
                if (config) {
                    let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : reelNum);
                    gsap.set(container, { pixi: { y: config[rn].reelY } });
                    if (anticipationAnim) gsap.set(anticipationAnim, anticipationProps);

                }
            } else {
                this.maskTimeline!.to(reelMask, maskProps, 0);
                if (config) {
                    let rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : reelNum);
                    this.maskTimeline!.to(container, { pixi: { y: config[rn].reelY } }, 0);
                    if (anticipationAnim) this.maskTimeline!.to(anticipationAnim, anticipationProps, 0);
                }
            }
        }
    }

    private playReelResetShake(): void {
        gsap.killTweensOf(this.allReelContainer);
        // const originalX = this.allReelContainer.x;

        // gsap.fromTo(
        //     this.allReelContainer,
        //     { x: originalX - 8 },
        //     {
        //         x: originalX + 8,
        //         duration: 0.08,
        //         yoyo: true,
        //         repeat: 5,
        //         ease: "power1.inOut",
        //         onComplete: () => {
        //             gsap.set(this.allReelContainer, { x: originalX });
        //         }
        //     }
        // );
    }

    private triggerLogoShake(): void {
        const logo = DisplayComponent.get(LogoComponent)?.getInstance() as Logo | undefined;
        logo?.playShake();
        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        sound.play("character_sound", { volume: 1, speed: timeScale });
    }


    // public resetMouseMeter() {

    //     let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    //     for (let i = 0; i < REEL_NUMBERS; i++) {
    //         if (!this.isMouseDown[i]) {
    //             this.mouseMeter[i].state.setAnimation(0, "end", false);
    //             this.mouseMeter[i].state.timeScale = timeScale;
    //             this.isMouseDown[i] = true;
    //         }


    //         this.mouseMultVal[i] = 0;
    //         this.mouseMultText[i].text = "";
    //         this.mouseMultText[i].scale = 0;
    //     }
    // }

    // public activateMouseMeter(mice: boolean[]) {

    //     let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    //     for (let i = 0; i < REEL_NUMBERS; i++) {
    //         if (mice[i]) {
    //             this.isMouseDown[i] = false;
    //             const mouse = this.mouseMeter[i];
    //             // sound.play('mice_showing_sound', { volume: 0.05, speed: timeScale });
    //             mouse.state.setAnimation(0, "start", false).listener = {

    //                 complete: () => {
    //                     mouse.state.clearListeners();
    //                     mouse.state.setAnimation(0, "loop", true);
    //                     mouse.state.timeScale = 1;
    //                 }
    //             }

    //             mouse.state.timeScale = timeScale;
    //         }
    //         else {
    //             this.isMouseDown[i] = true;
    //         }
    //     }
    // }

    // public slapMouse(reelNum: number, multiplier: number) {

    //     let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

    //     const mouse = this.mouseMeter[reelNum];

    //     mouse.state.addListener({
    //         event: (_entry, event) => {
    //             if (event.data.name === "multiplier") {
    //                 this.showMouseMultiplier(reelNum, multiplier);

    //             }
    //         },
    //         complete: () => {
    //             mouse.state.clearListeners();
    //         }
    //     })

    //     mouse.state.setAnimation(0, "slap", false)
    //     mouse.state.timeScale = timeScale;

    //     this.isMouseDown[reelNum] = true;
    // }

    // private async showMouseMultiplier(reelNum: number, multiplier: number) {

    //     this.mouseMultVal[reelNum] = multiplier;
    //     this.mouseMultText[reelNum].text = `${multiplier}x`;
    //     this.mouseMultText[reelNum].scale = 1;

    //     await new Promise((resolve) => setTimeout(resolve, 200));

    //     // this.multiplierValTotal = this.multiplierValTotal + multiplier;

    //     reelSpinEmitter.emit('collectMouseMult', multiplier, this.mouseMultText[reelNum]);

    //     this.mouseMultText[reelNum].scale = 0;
    // }

    private initReelOverlayContainer() {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.label = "reelOverlay";
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;

        this.toggleOverlayContainer = new Container();
        this.toggleOverlayContainer.label = "toggleOverlay";
        this.toggleOverlayContainer.x = this.allReelContainer.x;
        this.toggleOverlayContainer.y = this.allReelContainer.y;

        this.topOverlayContainer = new Container();
        this.topOverlayContainer.label = "topOverlay";
        this.topOverlayContainer.x = this.allReelContainer.x;
        this.topOverlayContainer.y = this.allReelContainer.y;

        this.addChild(this.reelOverlayContainer);
        this.addChild(this.toggleOverlayContainer);
        this.addChild(this.topOverlayContainer);

        let prevXPos = REEL_x_POS;
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            this.reelSymbolContainers[reelNum] = [];
            this.reelSymbols[reelNum] = [];

            let currentXPos = (reelNum === 0) ? prevXPos + Math.round(SYMBOL_WIDTH / 2) : prevXPos + REEL_WIDTH + REEL_DIVIDER[reelNum];

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
                const symbolCont = new Container();
                // symbolCont.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER[reelNum]);
                symbolCont.x = currentXPos;
                symbolCont.y = REEL_y_POS[reelNum] + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;

                this.reelOverlayContainer.addChild(symbolCont);
                this.reelSymbolContainers[reelNum][posNum] = symbolCont;
                this.reelSymbols[reelNum][posNum] = null!;
                const visPos = SYMBOLS_PER_REEL[reelNum] - VISIBLE_SYMBOLS_PER_REEL[reelNum];
                if (posNum >= visPos) {
                    symbolCont.visible = true;
                } else {
                    symbolCont.visible = false;
                }
            }
            prevXPos = currentXPos;
        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.reelOverlayContainer.addChild(this.anticipation[i]);
            if (i === 4) {
                this.reelOverlayContainer.addChild(this.wildAnticipation);
            }
        }
    }

    public addReelSymbolsToContainer2(reelNum: number) {
        const reelObj = this.allReelArray[reelNum];

        for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {

            // clean old symbol first
            const prevSymbol = this.reelSymbols[reelNum][posNum];
            if (prevSymbol) {
                this.reelSymbolContainers[reelNum][posNum].removeChild(prevSymbol);
                prevSymbol.destroy();
                this.reelSymbols[reelNum][posNum] = null;
            }
            else {
                const symbolId = reelObj.symbols[posNum].id;
                const symbol = getSpineSymbol(symbolId);
                this.reelSymbolContainers[reelNum][posNum].addChild(symbol);
                this.reelSymbols[reelNum][posNum] = symbol;
                if (symbolId == GameConstants.BLOCKED_SYMBOL_ID) {
                    this.reelSymbolContainers[reelNum][posNum].visible = false;
                } else {
                    const visPos = SYMBOLS_PER_REEL[reelNum] - VISIBLE_SYMBOLS_PER_REEL[reelNum];
                    if (posNum >= visPos) {
                        this.reelSymbolContainers[reelNum][posNum].visible = true;
                    } else {
                        this.reelSymbolContainers[reelNum][posNum].visible = false;
                    }

                }
            }

            this.reelSymbols[reelNum][posNum].state.setAnimation(0, "land", false);

        }

        // Defer visibility change to the next frame
        requestAnimationFrame(() => {
            this.setReelSpinContentVisibility(reelObj.container, false);
        });

    }

    public addReelSymbolsToContainer(reelNum: number) {
        const reelObj = this.allReelArray[reelNum];

        const visibleCount = VISIBLE_SYMBOLS_PER_REEL[1].toString();
        const configObj = REEL_BG_POS_ALL.find(obj => obj.hasOwnProperty(visibleCount));
        const config = configObj ? configObj[visibleCount as keyof typeof configObj] : null;

        if (config) {
            const rn = (reelNum > 0 && reelNum < 4) ? 1 : (reelNum === 4 ? 2 : 0);
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
                const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                symbolCont.y = config[rn].reelY + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
            }
        }

        let swildCount = 0;
        let gwildCount = 0;
        for (let wPos = 0; wPos < SYMBOLS_PER_REEL[reelNum]; wPos++) {
            if (reelObj.symbols[wPos].id === GameConstants.SILVER_WILD_SYMOL_ID) swildCount++;
            if (reelObj.symbols[wPos].id === GameConstants.GOLDEN_WILD_SYMOL_ID) gwildCount++;
        }

        const isSilverMode = this.isAfterFreeSpin && reelNum === 0 && swildCount > 0;
        const isGoldenMode = this.isAfterFreeSpin && reelNum === 4 && gwildCount > 0;
        const isWildOnlyMode = isSilverMode || isGoldenMode;

        let wildPresentTracker = false;

        for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {
            const symbolId = reelObj.symbols[posNum].id;
            const container = this.reelSymbolContainers[reelNum][posNum];

            const prevSymbol = this.reelSymbols[reelNum][posNum];
            if (prevSymbol) {
                container.removeChild(prevSymbol);
                prevSymbol.destroy();
            }

            const symbol = getSpineSymbol(symbolId);
            container.addChild(symbol);
            this.reelSymbols[reelNum][posNum] = symbol;

            const visPos = SYMBOLS_PER_REEL[reelNum] - VISIBLE_SYMBOLS_PER_REEL[reelNum];
            const isTargetWildId = (isSilverMode && symbolId === GameConstants.SILVER_WILD_SYMOL_ID) ||
                (isGoldenMode && symbolId === GameConstants.GOLDEN_WILD_SYMOL_ID);

            if (symbolId === GameConstants.BLOCKED_SYMBOL_ID) {
                container.visible = false;
            } else if (isWildOnlyMode) {
                container.visible = isTargetWildId && (posNum === 5 || posNum === 7);
            } else {
                container.visible = posNum >= visPos;
            }

            const isAnyWild = symbolId === GameConstants.SILVER_WILD_SYMOL_ID || symbolId === GameConstants.GOLDEN_WILD_SYMOL_ID;

            if (!isAnyWild) {
                symbol.state.setAnimation(0, "land", false);
            } else if (isWildOnlyMode && container.visible) {
                const currentWildCount = isSilverMode ? swildCount : gwildCount;

                if (posNum === 5 && currentWildCount < 3) {
                    symbol.state.setAnimation(0, "idle_down", false);
                    if (this.reelSymbolContainers[reelNum][6]) this.reelSymbolContainers[reelNum][6].visible = false;
                    if (this.reelSymbolContainers[reelNum][7]) this.reelSymbolContainers[reelNum][7].visible = false;
                    wildPresentTracker = true;
                } else if (posNum === 7 && !wildPresentTracker) {
                    symbol.state.setAnimation(0, "idle_up", false);
                    if (this.reelSymbolContainers[reelNum][6]) this.reelSymbolContainers[reelNum][6].visible = false;
                    if (this.reelSymbolContainers[reelNum][5]) this.reelSymbolContainers[reelNum][5].visible = false;
                }
            }
        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.reelOverlayContainer.addChild(this.anticipation[i]);
            if (i === 4) {
                this.reelOverlayContainer.addChild(this.wildAnticipation);
            }
        }

        requestAnimationFrame(() => {
            this.setReelSpinContentVisibility(reelObj.container, false);
        });
    }

    protected setReelSpinContentVisibility(reelContainer: Container, isVisible: boolean) {
        for (const child of reelContainer.children) {

            // keep grid always visible
            if (child.label?.startsWith("baseReelGrid_")) {
                child.visible = true;
                continue;
            }

            // keep mask always visible
            if (child.label?.startsWith("reelMask_")) {
                child.visible = true;
                continue;
            }

            // hide only symbol containers
            child.visible = isVisible;
        }
    }

    public resetReelOverlayContainer() {

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL[reelNum]; posNum++) {

                const prevSymbol = this.reelSymbols[reelNum][posNum];
                if (prevSymbol) {
                    this.reelSymbolContainers[reelNum][posNum].removeChild(prevSymbol);
                    prevSymbol.destroy();
                    this.reelSymbols[reelNum][posNum] = null;
                }
            }
        }

    }

}
